/**
 * FIR-09 y FIR-10 (Mario, 25-oct, en staging: «Yo me auto asigne el rol de tesorero, pero me sigue indicando que nadie lo tiene»).
 * Cuando nadie puede dar la próxima firma de una tanda, el aviso dice si de verdad nadie tiene el rol o si lo tiene
 * solo quien la preparó o ya la firmó (`con_rol_sin_poder` del núcleo), y el enlace abre Roles filtrado por ese rol.
 */

export interface ConRolSinPoder { id?: string; nombre: string; usuario?: string | null; porque: 'PREPARO' | 'YA_FIRMO' | string; tu?: boolean; }

const CODIGO: Record<string, string> = { TES: 'TESORERO', GER: 'GERENTE_FINANZAS', DIR: 'DIRECTOR' };

const conUsuario = (p: ConRolSinPoder): string => (p.usuario ? `${p.nombre} (${p.usuario})` : p.nombre);

/** La frase de la cinta; la plantilla le pone a continuación el enlace «Roles» y el punto. */
export function textoSinFirmante(rol: string, n: number, sp: ConRolSinPoder[] = []): string {
  const lista = sp || [];
  if (!lista.length) return `Nadie tiene el rol ${rol}: la tanda ${n} no se puede aprobar hasta asignarlo en`;
  const cierre = 'tiene que firmarla otra persona con ese rol. Asígnalo en';
  if (lista.length === 1) {
    const p = lista[0];
    if (p.tu) return `Solo tú tienes el rol ${rol} y ${p.porque === 'YA_FIRMO' ? 'ya firmaste' : 'preparaste'} la tanda ${n}: ${cierre}`;
    return `Solo ${conUsuario(p)} tiene el rol ${rol} y ${p.porque === 'YA_FIRMO' ? 'ya firmó' : 'preparó'} la tanda ${n}: ${cierre}`;
  }
  const nombres = lista.map((p) => (p.tu ? 'tú' : p.nombre)).join(', ');
  return `Quienes tienen el rol ${rol} ya prepararon o firmaron la tanda ${n} (${nombres}): ${cierre}`;
}

/** La etiqueta corta de la tanda (debajo de cada tarjeta de Por aprobar). */
export function etiquetaSinFirmante(rol: string, sp: ConRolSinPoder[] = []): string {
  const lista = sp || [];
  if (!lista.length) return `Nadie tiene el rol ${rol}`;
  if (lista.length > 1) return `Nadie más tiene el rol ${rol}`;
  const p = lista[0];
  if (p.tu) return `Solo tú tienes el rol ${rol} (${p.porque === 'YA_FIRMO' ? 'ya la firmaste' : 'preparaste la tanda'})`;
  return `Solo ${p.nombre} tiene el rol ${rol} (${p.porque === 'YA_FIRMO' ? 'ya la firmó' : 'preparó la tanda'})`;
}

/** FIR-10: Roles y Permisos en «Usuarios y Asignaciones», filtrado por el rol que falta. */
export const rolesParams = (k: string): { pestana: string; rol: string } => ({ pestana: 'usuarios', rol: CODIGO[k] || k });
